/**
 * City slug → display name mapping.
 *
 * CITY_MAP provides custom display names for known cities.
 * Any slug NOT in CITY_MAP is auto-converted to title case:
 *   "las-vegas" → "Las Vegas"
 *   "porto"     → "Porto"
 *
 * This means any city works out of the box — no manual activation
 * needed. Publish a walk with city: "las-vegas" and it goes live
 * immediately with "Las Vegas" as the display name.
 *
 * Use CITY_MAP only for overrides (e.g. "nyc" → "New York City").
 */
const CITY_MAP = {
  'los-angeles': 'Los Angeles',
  'new-york': 'New York',
  'san-francisco': 'San Francisco',
  'chicago': 'Chicago',
  'miami': 'Miami',
  'london': 'London',
};

const DEFAULT_CITY_SLUG = 'los-angeles';

/**
 * Convert a city slug to a display name.
 * Uses CITY_MAP if available, otherwise auto-generates from slug.
 */
export function cityDisplayName(slug) {
  if (!slug) return CITY_MAP[DEFAULT_CITY_SLUG];
  if (CITY_MAP[slug]) return CITY_MAP[slug];
  // Auto-generate: "las-vegas" → "Las Vegas"
  return slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

/**
 * Resolve the active city from available sources (priority order):
 * 1. Route param (e.g. /walks/us/los-angeles)
 * 2. Query param (e.g. ?city=los-angeles)
 * 3. User's profile city
 * 4. Default fallback
 *
 * @returns {{ slug: string, name: string }}
 */
export function resolveCity({ routeParam, filterParam, userCity } = {}) {
  const slug = routeParam || filterParam || userCity || DEFAULT_CITY_SLUG;
  return { slug, name: cityDisplayName(slug) };
}
